import { GeoFeatureBase, GeoFeatureInterface } from './geo-features';
import { PointFeature, PointFeaturesInterface } from './point';

export interface SegmentFeatureInterface extends GeoFeatureInterface {
  geometry: {
      type?: string;
      coordinates: [number, number][];
  }
  properties?: {
      name?: string;
      description?: string;
      points?: PointFeaturesInterface;
  }
}

export interface SegmentFeaturesInterface {
  type: string;
  features: SegmentFeatureInterface[];
}

export class SegmentFeature extends GeoFeatureBase {
  override geometryType: string = 'LineString';
  points: PointFeature[] = [];
  
  setPoints(points: PointFeaturesInterface | undefined) {
    if (points) {
      points.features.forEach(element => {
          let point = new PointFeature(element);
          this.points[point.id] = point;
      });
    }
  }
}
